import React, { Component } from 'react'
import { Button, Col, Row, Card, Form, Alert } from "react-bootstrap-v5";
import helperFunction from '../../../../Function/helperFunction'
import EnquiryService from "../../../../Services/EnquiryService";
import { toast } from 'react-toastify';

const DECIMALLENGTH = 3

class Cargo extends Component {

    constructor(props) {
        super(props)

        this.state = {
            booking: [],
            actual: [],
            quoteValue: null,
            cargoData: {}
        }
    }

    setData = () => {
        const { booking, actual } = this.state

        if ((booking.length == 0 || actual.length == 0)) {

            const { jobData } = this.props

            let bookingItems = jobData.map(item => {
                return item.booking
            })

            let actualItems = jobData.map(item => {
                return item.actual
            })

            this.setState({
                booking: bookingItems,
                actual: actualItems,
                cargoData: JSON.parse(JSON.stringify(actualItems)),
            })
        }
    }

    validateCargoFields = (statedata) => {
        let validateItems = statedata.filter((item1)=> {
            return ((Number(item1.no_of_pkgs) === 0 || Number(item1.no_of_pkgs) === "") 
                    || (item1.item_description === "")
                    || (Number(item1.height) === 0 || item1.height === "")
                    || (Number(item1.width) === 0 || item1.width === "")
                    || (Number(item1.length) === 0 || item1.length === "")
                    || (Number(item1.kilogram) === 0 || item1.kilogram === "")
                    )})
        return validateItems.length > 0
    }

    getQuote = () => {
        const { jobData, jobShipmentData, quoteToken, originData, destinationData } = this.props

        if(jobShipmentData.servic_type === '') {
            toast.error("Please select shipment service type")
            return false
        }

        let tempCopy = JSON.parse(JSON.stringify(jobData))

        // separate actual items data
        let actualItemOriginal = tempCopy.length && tempCopy.map(item => item.actual)

        let totalPackages = actualItemOriginal.reduce((total, item) => Number(item.no_of_pkgs) + total, 0)

        let totalVolume = actualItemOriginal.reduce((total, item) => Number(item.total_volume_CBM) + total, 0)

        let totalWeight = actualItemOriginal.reduce((total, item, currIndex) => Number(item.total_weight_KG) + total, 0)

        if(this.validateCargoFields(this.state.actual) || this.validateCargoFields(this.state.booking)){
            toast.error("Please fill Cargo required field")
            return false
        }
        let items = actualItemOriginal.map((item, idx) => {
            return {
                "item_id": "",
                "item_description": item.item_description,
                "no_of_pkgs": item.no_of_pkgs,
                "dimension": {
                    "kilogram": item.kilogram,
                    "length": item.length,
                    "width": item.width,
                    "height": item.height,
                },

                "total_volume_CBM": item.total_volume_CBM,
                "total_weight_KG": item.total_weight_KG,
                "item_token": jobData[idx].item_token ? jobData[idx].item_token : helperFunction.stringGenerator(24)
            }

        })

        let postData = {
            origin_country: originData.origin_country,
            origin_country_short_name: originData.origin_country_short_name,
            origin_city: originData.origin_city,
            origin_latitude: originData.origin_latitude,
            origin_longitude: originData.origin_longitude,
            destination_country: destinationData.origin_country,
            destination_country_short_name: destinationData.origin_country_short_name,
            destination_city: destinationData.origin_city,
            destination_latitude: destinationData.origin_latitude,
            destination_longitude: destinationData.origin_longitude,

            number_of_packages: totalPackages,
            volume: Number(totalVolume.toFixed(DECIMALLENGTH)),
            weight: Number(totalWeight.toFixed(DECIMALLENGTH)),
            items_goods: Number(jobShipmentData.value_of_goods),

            items: items,
            quote_token: quoteToken,
            referral_token: '',
            promo_code: '',
        }

        let getFinalQuotezKey;
        let sType = jobShipmentData.hasOwnProperty('servic_type') ? jobShipmentData.servic_type : jobShipmentData.service_type;

        if (sType.includes("PORT")) getFinalQuotezKey = 'port_delivery'
        if (sType.includes("DOOR")) getFinalQuotezKey = 'door_delivery'
        if (sType.includes("CONSOLIDATION")) getFinalQuotezKey = 'consolidation_delivery'

        let k = getFinalQuotezKey.replace('_delivery', '');

        sType.includes('AIR') && EnquiryService.postCheckAirQuote(postData).then((result) => {

            if (result.status === true) {
                let inputData = { name: 'booking_amount', value: result.all_data.final[getFinalQuotezKey][`discount_${k}_grant_total`] }

                this.setQuoteValue(inputData.value)
            }
        });

        sType.includes('SEA') && EnquiryService.postCheckSeaQuote(postData).then((result) => {

            if (result.status === true) {
                let inputData = { name: 'booking_amount', value: result.all_data.final[getFinalQuotezKey][`discount_${k}_grant_total`] }

                this.setQuoteValue(inputData.value)
            }
        });

        sType.includes('COURIER') && EnquiryService.postCheckCourierQuote(postData).then((result) => {

            if (result.status === true) {
                let inputData = { name: 'booking_amount', value: result.all_data.door_delivery.discount_door_grant_total }
                this.setQuoteValue(inputData.value)
            }
        });

        sType.includes('LAND') && EnquiryService.postCheckLandQuote(postData).then((result) => {

            if (result.status === true) {
                let inputData = { name: 'booking_amount', value: result.all_data.final[getFinalQuotezKey][`discount_${k}_grant_total`] }

                this.setQuoteValue(inputData.value)
            }
        });
    }

    setQuoteValue = (value) => {
        this.setState({quoteValue: value})
    }

    applyQuoteToActual = () => {
        const { cargoData, actual } = this.state
        const { paymentInformation } = this.props

        if(
            cargoData.length !== actual.length
        ){
            this.setState({show: true})
        }

        for (let i = 0; i < actual.length; i++) {
            if(
                Number(actual[i].width) !== Number(cargoData[i].width)
                || Number(actual[i].height) !== Number(cargoData[i].height)
                || Number(actual[i].length) !== Number(cargoData[i].length)
                || Number(actual[i].no_of_pkgs) !== Number(cargoData[i].no_of_pkgs)
                || Number(actual[i].kilogram) !== Number(cargoData[i].kilogram)
            ){
                this.setState({show: true})
                break;
            }
        }

        this.props.onChangeValue({ value: this.state.quoteValue }, 'payment_information', 'actual_amount')
        this.props.onChangeValue({ value: this.state.quoteValue }, 'payment_information', 'booking_amount')
        this.props.onChangeValue({ value: this.state.quoteValue }, 'payment_information', 'freight')

        if( Object.keys(paymentInformation).length !==0 ) {
            let breakdown = paymentInformation.breakdown
            breakdown.freight = this.state.quoteValue
            this.props.onChangeValue({ value: breakdown }, 'payment_information', 'breakdown')
        }
    }

    ShowAlert = () => {
        if(this.state.show){
            return (
                <Alert variant="warning" onClose={() => this.setState({show: false})} dismissible>
                    <Alert.Heading>Warning!</Alert.Heading>
                    <p>
                        Message goes here
                    </p>
                    <hr />
                    <div className="d-flex justify-content-end">
                    <Button onClick={() => this.setState({show: false})} variant="outline-warning">
                        Close me y'all!
                    </Button>
                    </div>
                </Alert>
            );
        }
    }

    handleAddClick = (type) => {

        const { jobData, quoteToken } = this.props

        let bookingAdd = [...this.state.booking, {
            freight_charges: 0,
            height: 0,
            item_description: "",
            kilogram: 0,
            length: 0,
            no_of_pkgs: 0,
            packing_charges: 0,
            total_volume_CBM: 0,
            total_weight_KG: 0,
            width: 0,
        }]
        let actualAdd = [...this.state.actual, {
            freight_charges: 0,
            height: 0,
            item_description: "",
            kilogram: 0,
            length: 0,
            no_of_pkgs: 0,
            packing_charges: 0,
            total_volume_CBM: 0,
            total_weight_KG: 0,
            width: 0,
        }]

        jobData.push(
            {
                booking: {},
                actual: {},
                add_ons_items: {},
                item_id: "",
                item_token: helperFunction.stringGenerator(24),
                quote_token:quoteToken
            }
        )

        actualAdd.map((item, index)=> {
            jobData[index]['actual'] = actualAdd[index]
            jobData[index]['booking'] = bookingAdd[index]
        })

        // this.setState({ [type]: letsAdd })
        this.setState({ 'booking': bookingAdd, 'actual': actualAdd })
    }


    handleRemoveClick = (type, index) => {
        const { jobData } = this.props
        const actualList = [...this.state.actual];
        const bookingList = [...this.state.booking];

        actualList.splice(index, 1);
        bookingList.splice(index, 1);
        jobData.splice(index, 1);

        this.setState({ 'booking': bookingList, 'actual': actualList })
    };

    handleInputChage = (event, type, index) => {
        const { jobData } = this.props
        const { name, value } = event.target;
        let list = this.state[type];
        let items = jobData

        list[index][name] = value

        this.setState(() => {
            return { [type]: list }
        })

        list.length && list.map((item, index) => {

            if(item['length'] !== 0 && item.width !== 0 && item.height !== 0){
                let dimension = {length: item.length, width: item.width, height: item.height }
                
                let total_volume = Number(item.no_of_pkgs) * helperFunction.calculateVolume(dimension)
                item.total_volume_CBM = helperFunction.handleDecimalPoints(total_volume,3)
                let total_weight = Number(item.no_of_pkgs) * Number(item.kilogram)
                item.total_weight_KG = helperFunction.handleDecimalPoints(total_weight,3)
            }

            items[index][type] = item
        })
        
        this.props.onChangeValue({ value: items }, 'quote_request_items', 'quote_request_items')
    }

    formList = (type, item, index, readOnly = false) => {
        const { removeBookingCount, formValidator } = this.props

        return (
            <Card bg='light' key={`${type}-${index}`}>
                <Card.Body>
                    <Card.Title>{type.toUpperCase()} - {index + 1}
                        {
                            // Number(removeBookingCount) < index + 1
                            (index > 0)
                            && (index - (this.props.jobData.filter((item)=> item?._id).length-1)) > 0
                            && 
                            <Button
                                className="float-end"
                                variant="danger"
                                size="sm"
                                onClick={() => this.handleRemoveClick(type, index)}
                            >Remove</Button>

                        }
                    </Card.Title>
                    <Row>
                        <Col>
                            <div className="d-flex">
                                <div className="position-relative me-2">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Description</Form.Label>
                                        <Form.Control
                                            key={`description-${type}-${index}`}
                                            value={item.item_description}
                                            readOnly={readOnly}
                                            name="item_description"
                                            onChange={(e) => this.handleInputChage(e, type, index)}
                                        />
                                    </Form.Group>

                                    {
                                    // formValidator.message('description', item.item_description, 'required', { className: 'text-danger' })
                                    }

                                </div>

                                <div className="position-relative me-2">
                                    <label className="form-label">Package</label>
                                    <input
                                        className="form-control form-control-sm"
                                        value={item.no_of_pkgs}
                                        readOnly={readOnly}
                                        name="no_of_pkgs"
                                        onKeyPress={(event) => {
                                            if (!/[0-9]/.test(event.key)) {
                                              event.preventDefault();
                                            }
                                        }}
                                        onChange={(e) => this.handleInputChage(e, type, index)}
                                    />

                                    {
                                    // formValidator.message('description', item.item_description, 'required', { className: 'text-danger' })
                                    }
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col>
                            <div className="d-flex">

                                <div className="position-relative me-2">
                                    <label className="form-label">Weight</label>
                                    <input
                                        className="form-control form-control-sm"
                                        value={item.kilogram}
                                        readOnly={readOnly}
                                        name="kilogram"
                                        onKeyPress={(event) => {
                                            const currentValue = event.target.value;
                                            const hasDecimalPoint = currentValue.includes(".");
                                            if ((!/[0-9]/.test(event.key) && event.key !== ".") || (event.key === "." && hasDecimalPoint) ) {
                                              event.preventDefault();
                                            }
                                        }}
                                        onChange={(e) => this.handleInputChage(e, type, index)}
                                    />

                                    {
                                    // formValidator.message('kilogram', item.kilogram, 'required', { className: 'text-danger' })
                                    }
                                </div>

                                <div className="position-relative me-2">
                                    <label className="form-label">Length</label>
                                    <input
                                        className="form-control form-control-sm"
                                        value={item.length}
                                        readOnly={readOnly}
                                        name="length"
                                        onKeyPress={(event) => {
                                           // if (!/[0-9]/.test(event.key)) {
                                            const currentValue = event.target.value;
                                            const hasDecimalPoint = currentValue.includes(".");
                                            if ((!/[0-9]/.test(event.key) && event.key !== ".") || (event.key === "." && hasDecimalPoint) ) {  
                                           event.preventDefault();
                                            }
                                        }}

                                        onChange={(e) => this.handleInputChage(e, type, index)}
                                    />

                                    {
                                    // formValidator.message('length', item.length, 'required', { className: 'text-danger' })
                                    }
                                </div>

                                <div className="position-relative me-2">
                                    <label className="form-label">Width</label>
                                    <input
                                        className="form-control form-control-sm"
                                        value={item.width}
                                        readOnly={readOnly}
                                        name="width"
                                        onKeyPress={(event) => {
                                            const currentValue = event.target.value;
                                            const hasDecimalPoint = currentValue.includes(".");
                                            if ((!/[0-9]/.test(event.key) && event.key !== ".") || (event.key === "." && hasDecimalPoint) ) {
                                              event.preventDefault();
                                            }
                                        }}
                                        onChange={(e) => this.handleInputChage(e, type, index)}
                                    />

                                    {
                                    // formValidator.message('width', item.width, 'required', { className: 'text-danger' })
                                    }
                                </div>

                                <div className="position-relative me-2">
                                    <label className="form-label">Height</label>
                                    <input
                                        className="form-control form-control-sm"
                                        value={item.height}
                                        readOnly={readOnly}
                                        name="height"
                                        onKeyPress={(event) => {
                                            const currentValue = event.target.value;
                                            const hasDecimalPoint = currentValue.includes(".");
                                            if ((!/[0-9]/.test(event.key) && event.key !== ".") || (event.key === "." && hasDecimalPoint) ) {
                                              event.preventDefault();
                                            }
                                        }}
                                        onChange={(e) => this.handleInputChage(e, type, index)}
                                    />

                                    {
                                    // formValidator.message('height', item.height, 'required', { className: 'text-danger' })
                                    }
                                </div>

                                <div className="position-relative me-2">
                                    <label className="form-label"><small>Total weight</small></label>
                                    {item.total_weight_KG && helperFunction.handleDecimalPoints(item.total_weight_KG,3) || 0}
                                </div>
                                <div className="position-relative me-2">
                                    <label className="form-label"><small>Total volume</small></label>
                                    {item.total_volume_CBM && helperFunction.handleDecimalPoints(item.total_volume_CBM,3) || 0}
                                </div>
                            </div>
                        </Col>
                    </Row>

                </Card.Body>
            </Card>
        )
    }

    setQuoteValue = (value) => {
        this.setState({quoteValue: value})
    }

    checkIsNotLocal = () => {
        let shipmentTypeLocal = [
          "LOCAL_MOVING",
          "LOCAL_TRANSPORT",
          "LOCAL_PACKING",
          "DOCUMENTATION",
          "OTHER_SERVICES",
        ];
        if (shipmentTypeLocal.includes(this.props.jobShipmentData.shipment_type)){
          return false;
        }else if (
          ["OTHER", "LOCAL", "OTHERLOCAL"].includes(
            this.props.jobShipmentData.servic_type
          )
        ){
          return false;
        }else if (
          ["OTHER", "LOCAL", "OTHERLOCAL"].includes(
            this.props.jobShipmentData.shipment_mode
          )
        ){
          return false;
        }
        return true;
      };

    componentDidMount() {
        this.setData();
    }

    render() {

        const { booking, actual, quoteValue } = this.state
        const { jobData, jobShipmentData, formValidator } = this.props
        if (!jobData || !Array.isArray(jobData)) return false

        return (
            <Card>
                <div className="card-header bg-light"><h4>Cargo Information</h4></div>
                <Card.Body>

                    <div className="row">
                        <div className="mb-3 col-md-6 col-12">
                            {
                                booking.map((item, index) => {
                                    return this.formList('booking', item, index, false)
                                })
                            }
                            <div className="row">
                                <div className="mb-3 col-md-3 col-12">
                                    <Button variant="warning" size='sm' onClick={() => this.handleAddClick('booking')}>Add Booking</Button>
                                </div>
                            </div>
                        </div>

                        <div className="mb-3 col-md-6 col-12">
                            {
                                actual.map((item, index) => {
                                    return this.formList('actual', item, index)
                                })
                            }
                            <div className="row">
                                <div className="mb-3 col-md-3 col-12">
                                    <Button variant="warning" size='sm' onClick={() => this.handleAddClick('actual')}>Add Actual</Button>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="mb-3 col-md-3 col-12">
                        <div className="mb-3">
                            <label className="form-label">Value of Goods</label>
                            <input className="form-control form-control-sm" readOnly value={jobShipmentData.value_of_goods} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="mb-3 col-md-6 col-12">
                            <label className="form-label">Comment</label>
                            <textarea className="form-control form-control-sm" />
                        </div>
                    </div>

                    <Row>
                        <Col className="mt-3">
                          {this.checkIsNotLocal() && (
                            <Button variant="info" onClick={() => this.getQuote()} size="sm">Get Quotes</Button>
                            )}
                        </Col>

                        <Col className="mt-3">
                            {quoteValue && <>
                                <span> Price of Quote: {quoteValue} </span>
                                <span> <Button variant="info" onClick={() => this.applyQuoteToActual()} size="sm">Apply</Button> </span>
                            </>}
                        </Col>
                    </Row>
                    
                    {/* {this.ShowAlert()} */}

                </Card.Body>
            </Card>
        )
    }
}

export default Cargo